import Icon from './Icon';

export default Icon;
export * as IconTypes from './Icon.types';
export * as IconStyles from './Icon.styles';
